import React from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const PageSection = ({id, sectiontitle, rightActions, children, ...props}) => (
  <Box id={id} {...props}>
    {(sectiontitle || rightActions) && (
      <Grid id={`${id}__title`} container justifyContent="space-between" alignItems="center" sx={{padding: "8px 0"}}>
        <Grid>
          <Typography
            variant="h4"
            gutterBottom
            sx={{
              margin: "4px",
              fontSize: 34,
              color: theme => theme.palette.text.primary
            }}
          >
            {sectiontitle}
          </Typography>
        </Grid>
        <Grid>{rightActions}</Grid>
      </Grid>
    )}
    {children}
    <Divider id={`${id}__divider`} sx={{margin: "24px 0"}} />
  </Box>
);

export default PageSection;
